import {Filter} from '../../../core/filter/filter';
import {LocalDate} from '@js-joda/core';
import {AbsenceType} from '../resource/absence';

export class PaidLeavesFilter  extends Filter {
  public employeeId?: number;
  public fromDate?: LocalDate;
  public toDate?: LocalDate;
  public absenceType?: AbsenceType;
}
